<template>
  <div>
    <template v-if="isOneClickEnabled && isOutboundIntegrationNumberASmrtPhoneNumber">
      <div style="display: none" :data-contact-number="oneClickSmrtPhoneContactNumber" :data-smrtphone-number="oneClickSmrtPhoneFromNumber"></div>
      <a
        v-if="includeButtonText"
        class="button is-secondary is-outlined"
        style="line-height: 38px; vertical-align: center;"
        :href="oneClickSmrtPhoneContactNumber"
        :data-from="oneClickSmrtPhoneFromNumber"
        :data-text="false"
        :data-lead-id="record ? record.id : null"
      >
        <span class="icon is-small mr-25">
          <icon-default icon="call" size="is-small"/>
        </span>
        Call
      </a>

      <a
        v-else
        class="button is-small is-secondary icon-button is-icon is-small"
        style="line-height: 26px"
        :href="oneClickSmrtPhoneContactNumber"
        :data-from="oneClickSmrtPhoneFromNumber"
        :data-text="false"
        :data-lead-id="record ? record.id : null"
      >
        <icon-default icon="call" size="is-small"/>
      </a>
    </template>
    <template v-else>
      <button-outlined
        v-if="includeButtonText"
        @click="callButtonClick"
        icon-left="phone"
        :color="canCall ? buttonColor : ''"
        :disabled="!canCall"
        :loading="isLoading"
        :title="callTitleText"
        :size="size"
        :is-short="size === 'is-small'"
      >Call
      </button-outlined>
      <button-icon
        v-else
        @click="callButtonClick"
        icon="call"
        :color="canCall ? buttonColor : ''"
        :disabled="!canCall"
        :loading="isLoading"
        :title="callTitleText"
      />
    </template>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import api from "../../../api";
import {SnackbarProgrammatic as Snackbar} from 'buefy';

export default {
  name: "CommButtonCall",
  props: {
    contact: {
      type: Object,
      required: true,
    },
    record: Object,
    availableRecords: Array,
    includeButtonText: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    canCall: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      isLoading: false,
      recordClone: this.record ? this.$utils.clone(this.record) : null,
      contactClone: this.contact ? this.$utils.clone(this.contact) : null,
    };
  },
  watch: {
    "contact"() {
      this.contactClone = this.contact ? this.$utils.clone(this.contact) : null
    }
  },
  computed: {
    user() {
      return this.$store.getters.authUser;
    },
    buttonColor() {
      return this.isPrimary ? "is-primary" : "is-secondary";
    },
    callTitleText() {
      if (this.canCall) return "Call Contact";

      if (!this.$store.getters.hasPhoneIntegration) return "Phone is not set up";

      return "Contact has no available phone numbers";
    },
    isOneClickEnabled() {
      return this.$store.getters.authUser.outbound_call_one_click;
    },
    oneClickIntegrationNumber() {
      const integrationNumberId = this.user.outbound_call_integration_number_id;
      return this.$store.getters.integrationPhoneNumbers.find(number => number.id === integrationNumberId);
    },
    campaignIntegrationNumber() {
      if (this.recordClone && this.recordClone.campaign_id) {
        const campaign = this.$store.getters.campaigns.find(campaign => campaign.id === this.recordClone.campaign_id);

        if (campaign && campaign.integrationPhoneNumber) {
          return campaign.integrationPhoneNumber;
        }

        return null
      }

      // checks if the call is coming from contact modal and contact has primary lead
      if (!this.recordClone && (this.contactClone && this.contactClone.primary_record_id)) {
        const record = this.availableRecords.find(record => record.id === this.contactClone.primary_record_id)
        const campaignId = record ? record.campaign_id : null;
        const campaign = this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);

        if (campaign && campaign.integrationPhoneNumber) {
          return campaign.integrationPhoneNumber;
        }
      }

      return null
    },
    outboundIntegrationNumber() {
      let phoneNumber = null;

      if (this.user.outbound_call_use_campaign && this.campaignIntegrationNumber) {
        phoneNumber = this.campaignIntegrationNumber;
      } else {
        phoneNumber = this.oneClickIntegrationNumber;
      }

      return phoneNumber;
    },
    outboundIntegration() {
      if (!this.outboundIntegrationNumber) return null

      return this.$store.getters.integrations.find(integration => {
        return integration.id === this.outboundIntegrationNumber.integration_id
      })
    },
    isOutboundIntegrationNumberASmrtPhoneNumber() {
      if (!this.outboundIntegration) return false

      return this.outboundIntegration.type === ENUMS.IntegrationTypeEnum.SmrtPhone.value
    },
    oneClickSmrtPhoneContactNumber() {
      const number = this.contact.phone_1;
      if (number) return 'tel:' + number.replace(/[^0-9]/g, '')
      return ''
    },
    oneClickSmrtPhoneFromNumber() {
      const number = this.outboundIntegrationNumber.number
      if (number) return number.replace(/[^0-9]/g, '')
      return ''
    },
  },
  methods: {
    callButtonClick() {
      if (this.isOneClickEnabled) {
        if (!this.outboundIntegrationNumber) {
          Snackbar.open({
            message: "You don't have a phone number setup for your one-click calling",
            type: 'is-warning',
            position: 'is-bottom',
            indefinite: true
          });

          return;
        }

        this.makeOneClickCall();
      }

      // Open call modal if one click is off
      else {
        this.$emit('openModal')
      }
    },
    makeOneClickCall() {
      const callForm = {
        record_id: this.recordClone ? this.recordClone.id : null,
        record_call: this.outboundIntegrationNumber.record_outbound_calls,
        user_number: this.user.outbound_call_cell_number,
        contact_number: this.contactClone.phone_1,
        integrationPhoneNumber: this.outboundIntegrationNumber,
      };

      this.isLoading = true;
      api.integrationPhoneNumbers.callContact(this.contactClone.id, callForm).then(() => {
        this.isLoading = false;

        this.$buefy.toast.open({
          message: `The call was started and will ring ${callForm.user_number}`,
          type: "is-success"
        });
      });
    },
  }
}
</script>
